<template>
  <el-dialog
  title="查看提成申诉"
  :visible.sync="visibleDialog"
  width="640px"
  top="calc(50vh - 300px)"
  class="pop-dialog pop-check-apply"
  append-to-body>
<div class="shensu-info" v-loading="loading">
    <!-- 审核中 -->
     <template v-if="detail.auditStatus === 0">
        <div class="shensu-top">
          <img src="https://fenxiao.muruji.com/internalSystem/c4d0998c-1e84-4767-ac47-45347fcb3b59" class="img">
          <div class="shensu-title">审核中...</div>
          <div class="shensu-tips">正在审批该订单的提成改为<span class="danger">{{detail.bonusTypeLabel}}</span>的申请。</div>
        </div>
        <div class="shensu-content">
          <div class="form-row">
            <div class="lable">图片证据：</div>
            <div class="img-list">
              <div class="img" v-for="(url, index) of detail.urls" :key="index">
                <el-image class="image" :src="url" fit="contain"></el-image>
                <div class="look">查看</div>
                <el-image class="image image-click" :src="url" fit="contain" :preview-src-list="detail.urls"></el-image>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="lable">申诉备注：</div>
            <div class="text ">{{detail.reason}}</div>
          </div>
          <div class="form-row">
            <div class="lable">提交审核人：</div>
            <div class="text ">{{detail.applyName}}</div>
          </div>
          <div class="form-row">
            <div class="lable">提交时间：</div>
            <div class="text ">{{detail.applyTime}}</div>
          </div>
        </div>

        <div class="button-con">
          <el-button class="btn-cancel" @click="visibleDialog = false" size="mini">取 消</el-button>
          <!-- 本人才可以撤销申诉 -->
          <el-button class="btn-ok" type="primary" @click="cancelApply"  size="mini" v-if="detail.applyName === userInfo.reallyName">撤销申诉</el-button>
        </div>
    </template>
    <!-- 撤销 -->
    <template v-if="detail.auditStatus === 1">
          <div class="shensu-top">
            <img src="https://fenxiao.muruji.com/internalSystem/0985f322-bc3d-4fce-a4f0-a33fc0619288" class="img">
            <div class="shensu-title shensu-title-cancel">撤销申诉</div>
            <div class="shensu-tips">您已撤销订单的提成变更的申请。</div>
          </div>
          <div class="shensu-content">
            <div class="form-row">
              <div class="lable">图片证据：</div>
              <div class="img-list">
                <div class="img" v-for="(url, index) of detail.urls" :key="index">
                  <el-image class="image" :src="url" fit="contain" ></el-image>
                  <div class="look">查看</div>
                  <el-image class="image image-click" :src="url" fit="contain" :preview-src-list="detail.urls"></el-image>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="lable">申诉备注：</div>
              <div class="text ">{{detail.reason}}</div>
            </div>
            <div class="form-row">
              <div class="lable">撤销审核人：</div>
              <div class="text ">{{detail.applyName}}</div>
            </div>
            <div class="form-row">
              <div class="lable">撤销时间：</div>
              <div class="text ">{{detail.applyTime}}</div>
            </div>
          </div>
          <div class="button-con">
            <el-button class="btn-cancel" @click="visibleDialog = false"   size="mini">取 消</el-button>
          </div>
    </template>
    <!-- 通过 -->
    <template v-if="detail.auditStatus === 2">
      <div class="shensu-top">
        <img src="https://fenxiao.muruji.com/internalSystem/84cfe386-00bd-4c92-b0e3-ea1dac4051a0" class="img">
          <div class="shensu-title shensu-title-success">审核结果：{{detail.auditStatusLabel}}</div>
          <div class="shensu-tips">系统提成类型更改为<span class="danger">{{detail.bonusTypeLabel}}</span></div>
        </div>
        <div class="shensu-content">
          <div class="form-row">
            <div class="lable">图片证据：</div>
            <div class="img-list">
              <div class="img" v-for="(url, index) of detail.urls" :key="index">
                <el-image class="image" :src="url" fit="contain"></el-image>
                <div class="look">查看</div>
                <el-image class="image image-click" :src="url" fit="contain" :preview-src-list="detail.urls"></el-image>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="lable">申诉备注：</div>
            <div class="text ">{{detail.reason}}</div>
          </div>
          <div class="form-row">
            <div class="lable">审核人：</div>
            <div class="text ">{{detail.auditUserName}}</div>
          </div>
          <div class="form-row">
            <div class="lable">审核时间：</div>
            <div class="text ">{{detail.applyTime}}</div>
          </div>
          <div class="form-row">
            <div class="lable">审核备注：</div>
            <div class="text ">{{detail.auditRemarks}}</div>
          </div>
        </div>
        <div class="button-con">
          <el-button class="btn-ok" type="primary" @click="visibleDialog = false"  size="mini">好 的</el-button>
        </div>
    </template>
    <!-- 驳回 -->
    <template v-if="detail.auditStatus === 3">
      <div class="shensu-top">
        <img src="https://fenxiao.muruji.com/internalSystem/504f2ae5-1656-4515-8eab-b243fc95139f" class="img">
          <div class="shensu-title shensu-title-danger">审核结果：{{detail.auditStatusLabel}}</div>
          <div class="shensu-tips">提成申诉失败，订单提成仍为<span class="danger">{{detail.oldBonusTypeLabel}}</span></div>
        </div>
        <div class="shensu-content">
          <div class="form-row">
            <div class="lable">图片证据：</div>
            <div class="img-list">
              <div class="img" v-for="(url, index) of detail.urls" :key="index">
                <el-image class="image" :src="url" fit="contain"></el-image>
                <div class="look">查看</div>
                <el-image class="image image-click" :src="url" fit="contain" :preview-src-list="detail.urls"></el-image>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="lable">申诉备注：</div>
            <div class="text ">{{detail.reason}}</div>
          </div>
          <div class="form-row">
            <div class="lable">审核人：</div>
            <div class="text ">{{detail.auditUserName}}</div>
          </div>
          <div class="form-row">
            <div class="lable">审核时间：</div>
            <div class="text ">{{detail.applyTime}}</div>
          </div>
          <div class="form-row">
            <div class="lable">审核备注：</div>
            <div class="text ">{{detail.auditRemarks}}</div>
          </div>
        </div>
        <div class="button-con">
          <el-button class="btn-ok" type="primary"  @click="visibleDialog = false"  size="mini">好 的</el-button>
        </div>
    </template>
     <!-- 被修改 -->
     <template v-if="detail.auditStatus === 4">
      <div class="shensu-top">
        <img src="https://fenxiao.muruji.com/internalSystem/a2b91ead-64de-4729-bc7f-eac4db967a7c" class="img">
          <div class="shenhe-tips">系统提成类型更改为<span class="danger">{{detail.bonusTypeLabel}}</span>。</div>
        </div>
        <div class="shensu-content">
          <div class="form-row">
            <div class="lable">图片证据：</div>
            <div class="img-list">
              <div class="img" v-for="(url, index) of detail.urls" :key="index">
                <el-image class="image" :src="url" fit="contain"></el-image>
                <div class="look">查看</div>
                <el-image class="image image-click" :src="url" fit="contain" :preview-src-list="detail.urls"></el-image>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="lable">修改备注：</div>
            <div class="text ">{{detail.reason}}</div>
          </div>
          <div class="form-row">
            <div class="lable">修改人：</div>
            <div class="text ">{{detail.applyName}}</div>
          </div>
          <div class="form-row">
            <div class="lable">修改时间：</div>
            <div class="text ">{{detail.applyTime}}</div>
          </div>
        </div>
        <div class="button-con">
          <el-button class="btn-ok" type="primary"  @click="visibleDialog = false"  size="mini">好 的</el-button>
        </div>
    </template>
  </div>
</el-dialog>
</template>
<script>

  export default {
    name:'popCheckApply',
    data () {
      return {
        visibleDialog:false,
        userInfo: {},
        loading: false,
        detail: {
          auditStatus:'',
          urls:[]
        },
        orderObj:{}
      }
    },

    methods: {
       // 批量设置不需要回显
      show(item) {
        console.log('show>>',item)
        this.id = item.orderNo
        this.textarea = ''
        this.visibleDialog = true
        this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        // const id = this.orderObj.orderBonusResponse && this.orderObj.orderBonusResponse.id || this.orderObj.applyId
        this.getDetail(this.id)
      },
 // 获取详情
    getDetail (id) {
      this.loading = true
      this.detail = {}
      this.$api.omsApplyDetail(id).then((res) => {
        if (res.code === 0) {
          const detail = res.data
          // 字符串转数组
          if (detail.fileUrls) {
            detail.urls = detail.fileUrls.split(',')
          }
          this.detail = detail
        }
      }).finally(() => {
          this.loading = false
        })
    },
    // 撤销申诉
    cancelApply () {
      this.loading = true
      this.detail = {}
      this.$api.omsCancelApply(this.id).then((res) => {
        if (res.code === 0) {
          this.$message.success('已撤销申诉')
          this.$emit('fetchData')
          this.getDetail(this.id)
        }
        this.loading = false
      }).finally(() => {
         this.loading = false
      })
    },
    },
  }
</script>
<style lang='scss'>
.pop-check-apply{
  .shensu-info {
    padding-top: 20px;
    .images{
      .el-form-item__content{
        line-height: 1;
      }
    }
    .shensu-top{
      text-align: center;
      margin-bottom: 30px;
      .img{
        width: 120px;
        height: 120px;
        display: block;
        margin: 0 auto 8px;
      }
      .shensu-title{
        font-size: 20px;
        font-weight: bold;
        color: #4168E7;
        margin-bottom: 10px;
      }
      .shensu-title-cancel{
        color: #999999;
      }
      .shensu-title-success{
        color: #12AB62;
      }
      .shensu-title-danger{
        color: #F33F3F;
      }
      .shensu-tips{
        font-size: 14px;
        color: #333;
        
      }
    }
    .shensu-content{
      background-color: #F8F8F8;
      padding: 16px 16px 2px 0;
      margin-bottom: 20px;
      .lable{
        display: inline-block;
        width: 98px;
        text-align: right;
        white-space: nowrap;
        flex-shrink: 0;
      }
    }
    .img-list {
          display: flex;
      
          .img {
            width: 64px;
            height: 64px;
            margin-right: 8px;
            position: relative;
            .look {
              opacity: 0;
              transition: opacity .3s;
              position: absolute;
              inset: 0;
              background-color: rgba(51, 51, 51, .3);
              line-height: 1;
              color: #FFF;
              font-size: 12px;
              display: flex;
              justify-content: center;
              align-items: center;
              &::before{
                display: block;
                content: '';
                width: 16px;
                height: 16px;
                background-image: url('https://fenxiao.muruji.com/internalSystem/37e22265-773f-4f1a-83af-728b1aab3ea5');
                background-size: 100%;
                margin-right: 4px;
              }
            }
            &:hover {
              .look {
                opacity: 1;
              }
            }
          }
      
          .image {
            width: 64px;
            height: 64px;
            object-fit: cover;
          }
          .image-click{
            position: absolute;
            inset: 0;
            opacity: 0;
          }
        }
    .info {
      padding-top: 15px;
      line-height: 1;
      margin-bottom: 10px;
      font-size: 12px;
      color: #999999;
    }
  
    .form-row {
      margin-bottom: 20px;
      color: #333;
    }
    .form-row {
      flex: 1;
      display: flex;
      margin-bottom: 10px;
      .lable{
        white-space: nowrap;
      }
    }
    .upload-list{
      line-height: 1;
    }
      .el-form{
        line-height: 1;
      }
      .el-form-item__label{
        color: #333;
      }
      .el-upload-list__item,
      .el-upload--picture-card {
        width: 128px;
        height: 128px;
        margin-bottom:0;
        border-radius:0;
        
      }
      .el-upload-list__item{
        margin-bottom: 6px;
      }
      .el-upload--picture-card{
        line-height: 128px;
        background-color: #fff;
        border: 1px dashed #D9D9D9;
        margin-bottom: 7px;
      }
      .el-textarea__inner{
        height: 88px;
      }
    .upload-list .el-form > div{
      text-align: left;
    }
    .el-form-item__error{
      padding-top: 0;
      top: calc(100% - 4px);
    }
    // 限制6个
    .upload-list .el-form .upload-6 {
      .el-upload{
        display: none;
      }
    }
    .button-con{
      text-align: center;
      padding-bottom: 20px;
      
    }
    .button-con-right{
      text-align: right;
    }
  }
}
</style>